<template>
  <div id="card" class="card">
    <div class="student">
      <img :src="src" alt="考生头像">
      <span class="student-name">{{ name }}</span>
    </div>
    <div id="infonmation" v-if="showAllInformation" class="infonmation">
      <div 
        v-for="(item, index) of informationList" 
        :key="index" 
        class="row"
        :class="{addClass: item.addClass}"
      >
        <span class="key">{{ item.key }}</span>
        <span class="value">{{ item.value }}</span>
      </div>
    </div>
  </div>
</template>

<script>
import woman from 'img/woman.png'
import man from 'img/man.png'
import { computed, onUpdated } from 'vue'
export default {
  name: 'CommonInformationCard',
  props: {
    // 是否显示全部基本信息
    showAllInformation: {
      type: Boolean,
      default: true
    },
    // 基本信息列表
    informationList: {
      type: Array,
      required: true
    },
    // 姓名
    name: {
      type: String,
      required: true
    }
  },
  setup (props) {
    const src = computed(() => {
      let img
      if (props.informationList.length > 0) {
        if (props.informationList[0].value === '男') {
          img = man
        } else {
          img = woman
        }
      }
      return img
    })
    onUpdated(() => {
      adjustmentHeight()
    })
    // 调整基本信息card高度
    const adjustmentHeight = () => {
      if (props.showAllInformation) {
        const height = document.getElementById('infonmation').clientHeight
        const finaHeight = height + 30
        document.getElementById('card').style.height = `${finaHeight}px`
      }
    }
    return {
      woman,
      man,
      src,
      adjustmentHeight
    }
    // &.addClass {
    //   margin-top: 14px;
    // }
  }
}
</script>
<style lang="scss" scoped>
@import 'scss/base.scss';
@import 'scss/color.scss';
.card {
  display: flex;
  flex-direction: column;
  position: relative;
  margin: 0 auto;
  width: 702px;
  padding: 30px;
  box-sizing: border-box;
  background-color: #fff;
  border-radius: 0px 0px 16px 16px;
  box-shadow: 0 5px 14px 0 rgba(0, 0, 0, .05);
  .student {
    @include flex-center;
    img {
      width: 32px;
      height: 34px;
    }
    &-name {
      font-size: 32px;
      color: #333;
      margin-left: 10px;
      font-weight: bold;
    }
  }
  .infonmation {
    display: flex;
    flex-direction: column;
    padding: 30px 0 10px 0;
    box-sizing: border-box;
    justify-content: space-between;
    flex: 1;
    .row {
      display: flex;
      justify-content: space-between;
      font-size: 28px;
      align-items: center;
      line-height: 65px;
      .key {
        color: $color-gray;
        width: 240px;
      }
      .value {
        text-align: right;
        line-height: 40px;
        color: #333;
        max-width: 420px;
      }
    }
  }
}
</style>
